import React from "react";
import styled from "styled-components";
import theme from "../../../utils/jsTheme";
import ParametersIcons from "./ParameterIcon";
import getColor from "../../../utils/interpolateColor";
// import { useTranslation } from "../../../hooks/useTranslation.js";

const PieWrapper = styled.div`
  height: ${(props) => props.$circleSize}px;
  width: ${(props) => props.$circleSize}px;
  margin-top: ${(props) => props.$mtop || 0}px;
  margin-bottom: ${(props) => props.$mbottom || 0}px;
  position: relative;
`;

const CircleProgress = styled.svg`
  width: ${(props) => props.$circleSize}px;
  height: ${(props) => props.$circleSize}px;
  viewbox: "0 0 ${(props) => props.$circleSize} ${(props) =>
    props.$circleSize}";
`;
const CircleBackground = styled.circle`
  fill: none;
  stroke: ${(props) => props.$strokeClr};
  r: ${(props) => props.$circleRadius};
`;

const CircleForeground = styled.circle`
  fill: none;
  stroke: ${(props) => (props.$score > 0 ? props.color : "none")};
  stroke-linecap: round;
  stroke-dasharray: ${(props) => 2 * Math.PI * props.$circleRadius};
  stroke-dashoffset: ${(props) =>
    props.$score === 100
      ? 0
      : 2 * Math.PI * props.$circleRadius -
        (props.$score / 100) * (2 * Math.PI * props.$circleRadius)};
  transition: stroke-dashoffset 0.6s ease 0s;
  r: ${(props) => props.$circleRadius};
  transform: rotate(-90deg);
  transform-origin: center;
`;

const Icons = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
`;

// ScoreText not currently used

// Logo not currently used

const ReportDescCirlceChart = ({
  name,
  score,
  originalSize = 200,
  originalRadius = 80,
  strokeWidth = 6,
  reductionFactor = 1,
  strokeClr = theme.colors.bg.grey,
  mtop,
  mbottom,
  healthPlus = false,
  
}) => {
  const circleSize = originalSize * reductionFactor;
  const circleRadius = originalRadius * reductionFactor;
  const center = circleSize / 2;
  console.log(name)
  // Circle progress color
  const primeColor = getColor(score);
  // const { t } = useTranslation();

  return (
    <PieWrapper className="tw-mr-2" $circleSize={circleSize} $mtop={mtop} $mbottom={mbottom}>
      <CircleProgress $circleSize={circleSize}>
        <CircleBackground
          cx={center}
          cy={center}
          r={circleRadius - strokeWidth / 2}
          strokeWidth={strokeWidth}
          $circleRadius={circleRadius}
          $strokeClr={strokeClr}
        />
        <CircleForeground
          cx={center}
          cy={center}
          r={circleRadius - strokeWidth / 2}
          strokeWidth={strokeWidth}
          $score={score}
          color={primeColor}
          $circleRadius={circleRadius}
        />
      </CircleProgress>
      <Icons>
          <ParametersIcons
            title={name}
            width={name === "Hälsa" ? healthPlus ? 28 : 36 : 36}
            healthPlus={healthPlus}
          />
        </Icons>
        
    </PieWrapper>
  );
};

export default ReportDescCirlceChart;
